module.exports = __webpack_public_path__ + "static/img/digita_06.833db3cb.jpg";